import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
//icons
import { FaEdit } from 'react-icons/fa';
import { AiFillDelete, AiOutlineEye } from 'react-icons/ai';
import { BsSearch } from 'react-icons/bs';
import { GiBroom } from 'react-icons/gi';
//api
import { getCommissionsByCompany } from 'api/orders';
//components
import CustomInput from 'components/backoffice/customInput';
import CustomTable from 'components/backoffice/customTable';
import DropdownIcons from 'components/backoffice/dropDownIcons';
import ButtonCustom from 'components/backoffice/buttonCustom';

const colsCommissionsByCompany = [
  'Empresa',
  'Nº ordenes',
  'Comisiones por retiro',
  'Comisiones lib. beneficiada',
  'Comisiones proveer libro',
  'Comisión fija a Libelista',
  'Suma total',
  '',
];

const CommissionsByCompany = () => {
  const navigate = useNavigate();
  const [listCommissionsByCompany, setListCommissionsByCompany] = useState([]);
  const [noResults, setNoResults] = useState(false);
  const [totalPages, setTotalPages] = useState(null);
  const [isActiveSearch, setIsActiveSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const query = {
    page: 1,
    page_size: 10,
  };
  const searchQuery = new URLSearchParams(query);
  const queryString = searchQuery.toString();

  const getListCommissionsByCompany = async () => {
    setIsLoading(true);
    const { data, status } = await getCommissionsByCompany();
    if (status === 200 && data.length > 0) {
      setListCommissionsByCompany(data);
      setNoResults(false);
    } else {
      setListCommissionsByCompany([]);
      setNoResults(true);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getListCommissionsByCompany();
  }, []);

  const handleClear = () => {
    setNoResults(false);
    navigate('/intranet/commissions-by-company');
  };

  return (
    <div className="h-100 ml-70">
      <div className="d-flex mt-3 justify-content-between">
        <h1 className="text-light mt-5">Comisiones por empresa</h1>
      </div>

      <div className="d-flex my-5">
        <CustomInput
          //handleSubmit={(e) => handleSubmit(e)}
          placeholder="Buscar por nombre "
          icon={<BsSearch color="#161A25" className="icon-search" />}
          type={'search'}
        />
        <ButtonCustom onClick={handleClear} color="terciary">
          <GiBroom />
        </ButtonCustom>
      </div>
      <CustomTable
        cols={colsCommissionsByCompany}
        noResults={noResults}
        isLoading={isLoading}
        className="custom-table-commissions"
      >
        {listCommissionsByCompany &&
          listCommissionsByCompany.map((listCommissionByCompany, index) => {
            return (
              <tr key={listCommissionByCompany.id} className="text-center">
                <td>{listCommissionByCompany.company}</td>
                <td>{listCommissionByCompany.orders_quantity}</td>
                <td>{listCommissionByCompany.bookstore_pickup_total}</td>
                <td>{listCommissionByCompany.benefited_company_total}</td>
                <td>{listCommissionByCompany.books_provided_total}</td>
                <td>{listCommissionByCompany.libe_fixed_comission}</td>
                <td>{listCommissionByCompany.total}</td>
                <td className=" item-dropdown text-end">
                  <DropdownIcons idItem={index} />
                </td>
              </tr>
            );
          })}
      </CustomTable>
    </div>
  );
};

export default CommissionsByCompany;
